import { CarbonDate } from "../group/groupModels"

export interface InitialState {
    currTemplate: Template,
    prevTemplate: Template,
    isTemplateEditor: boolean,
}

export interface Template{
    template_id     : string,
    category        : number, //1: public template, 2: private template
    width           : number,
    height          : number,
    target_layout   : number, // 0: Landscape, 1: Portrait
    template_name   : string,
    positions?      : Position[],
    user_template_id?: string, // no require when create a new template
    user_template_name?: string, // no require when create a new template
    in_used? : boolean // true if this template has been used to create at least one campaign
    created_at?: string | null,
    updated_at?: string | null,
}

export interface Position{
    position_id         : string,
    template_id         : string,
    element_type        : string,
    alias               : string,
    default_source_id?   : string,    
    layer               : number,    
    selectable          : number,    
    x   : number,
    y   : number
    w   : number,
    h   : number, 

    // x: number,
    // y: number,
    // width: number,
    // height: number,
    // key: number | string,
    // fill?: string
}

export interface Section {  //like position in template
    id: string,
    x: number,
    y: number,
    width: number,
    height: number,
    key?: number | string,
    fill?: string,
    stroke?: string,
    type: string,
  }

export interface iCopyTemplate{
    template_id: string,
    new_template_name?: string
}

export interface NewTemplateSetting {
    selectedSect: string,   //alias of the selected section/position
    orientation: string,    
    ratio : string,
    type: string,
}

// -----------------------------------------------
// export const emptyTemplate : Template = {
//     template_id: "",
//     category        : 0,
//     width           : 0,
//     height          : 0,
//     target_layout   : 0,
//     template_name   : "",
// }

export const ASPECT_RATIOS = [
  
    ["16:9", 16, 9, 3],
    ["5:4", 5, 4, 6],
    ["4:3", 4, 3, 6],
    ["2:1", 2, 1, 15],

    ["9:16", 9, 16, 3],
    ["4:5", 4, 5, 6],
    ["3:4", 3, 4, 6],
    ["1:2", 1, 2, 15],

    ["Square", 1, 1, 25],
    ["Full L", 16, 9, 4],
    ["Full P", 9, 16, 4],

    // ["Free", 2, 5, 6],    
]

export const defaultPositionLandscape: Position = {
    position_id: "",
    template_id: "",
    x: 0,
    y:0,
    w:1920,
    h:1080,
    layer: 1,
    element_type: 'video',
    alias: Math.random().toString(9).slice(0,5).replace('0.', '').toUpperCase(),
    default_source_id: '0',
    selectable: 1
} 

export const defaultPositionPortrait: Position = {
    position_id: "",
    template_id: "",
    x: 0,
    y:0,
    w:1080,
    h:1920,
    layer: 1,
    element_type: 'video',
    alias: Math.random().toString(9).slice(0,5).replace('0.', '').toUpperCase(),
    default_source_id: '0',
    selectable: 1
} 

export const defaultTemplateLandscape: Template = {
            template_id: "",
            template_name : "",
            width: 1920,
            height: 1080,
            target_layout: 0,   //0: landscape, 1: portrait
            category: 2,    //1: public, 2: private
            positions: [defaultPositionLandscape],
            created_at: null,
            updated_at: null,
}

export const defaultTemplatePortrait: Template = {
    template_id: "",
    template_name : "",    
    width: 1080,
    height: 1920,
    target_layout: 0,   //0: landscape, 1: portrait
    category: 2,    //1: public, 2: private
    positions: [defaultPositionPortrait],
    created_at: null,
    updated_at: null,
}   




